import React from 'react';
import Gallery from '../../components/gallery/Gallery';
import styles from './GalleryContainer.module.css';

const GalleryContainer = ({ images }) => {
  return (
    <div className={styles.galleryContainer}>
      <h2 className={styles.heading}>行程相片</h2>
      <Gallery images={images} />
    </div>
  );
};

export default GalleryContainer;
